import { render, staticRenderFns } from "./SourcePreviewCard.vue?vue&type=template&id=1fc75d74&scoped=true&"
import script from "./SourcePreviewCard.vue?vue&type=script&lang=js&"
export * from "./SourcePreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./SourcePreviewCard.vue?vue&type=style&index=0&id=1fc75d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc75d74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VIcon,VSpacer})
